<template>
  <div class="text-right">
    <m-loading-3/>
    <router-view/>

  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: 'app',
  components: {},
  mounted() {

    document.title = findAttributeOnSiteInfo('site_name')[0];

  }
}
</script>

<style>



</style>